import * as React from 'react';

import { observer } from 'mobx-react';

import { Dropdown } from '@estee/elc-dropdown';
import { Field, FormInput } from '@estee/elc-form';

import { IApiSelectSource } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { fieldLabelClasses } from '~utils/Classes';
import { ApiDropDownViewController } from '~views/components/ApiDropDownViewController';

import { IDropDownProps } from './DropDown';

export interface IApiDropDownProps extends IDropDownProps {
    inputLabel: string;
    source: IApiSelectSource;
    additionalFormValues?: string[];
}

@observer
export class ApiDropDown extends React.Component<IApiDropDownProps> {
    private apiDropDownViewController: ApiDropDownViewController;

    constructor(props: IApiDropDownProps) {
        super(props);
        this.apiDropDownViewController = diContainer.get(serviceNames.apiDropDownViewController);
    }

    public componentDidMount() {
        this.apiDropDownViewController.loaded(this.props.name);
    }

    private afterFieldChange = (fieldName: string, fieldValue: string) => {
        const {
            source: { triggerLength }
        } = this.props;
        if (fieldValue.length === triggerLength) {
            this.apiDropDownViewController.onApiInputChange(fieldName, fieldValue, this.props);
        }
    };

    private onDropDownChange = (fieldName: string, fieldValue: string) => {
        this.apiDropDownViewController.onApiDropDownChange(fieldName, fieldValue, this.props);
    };

    public render() {
        const {
            name,
            inputLabel,
            disabled,
            fieldValidations,
            formStore,
            withFloatingLabel
        } = this.props;
        const {
            onApiDropDownClickOutside,
            data: { options, isSelectable }
        } = this.apiDropDownViewController;
        const { isRequired, maxLength, validations } = fieldValidations || {};

        return (
            <>
                {!withFloatingLabel && (
                    <div className={fieldLabelClasses(name, isRequired)}>{inputLabel}</div>
                )}

                {isSelectable ? (
                    <Field
                        name={name}
                        dataTestId={`form_${name}`}
                        component={FormInput}
                        inputType="text"
                        maxLength={maxLength}
                        isRequired={false}
                        inputLabel={withFloatingLabel ? inputLabel : ''}
                        disabled={disabled}
                        afterChange={this.afterFieldChange}
                        inputValue={formStore.values[name]}
                        validations={validations}
                        formStore={formStore}
                    />
                ) : (
                    <Dropdown
                        {...this.props}
                        options={options}
                        onChange={this.onDropDownChange}
                        placeholder={withFloatingLabel ? inputLabel : ''}
                        isOpenByDefault={true}
                        selectedValue={formStore.values[name]}
                        dataTestId={`form_${name}`}
                        dropdownClickOutside={onApiDropDownClickOutside}
                    />
                )}
            </>
        );
    }
}
